import { Pipe, PipeTransform } from '@angular/core';
import { MeasurementUnit } from '../models/measurementUnit';
import { ImperialDistanceUnit } from '../models/measurementSystem';
import { UnitConverter } from '../utils/unitConverter';
import { GlobalSettings } from '../models/globalSettings';

@Pipe({
    name: 'unitConverter',
    standalone: true
})
export class UnitConverterPipe implements PipeTransform {

	transform(
		value: number,
		unit: MeasurementUnit = 'distance',
		imperialDistanceUnit: ImperialDistanceUnit = 'inches',
		accuracy: number = GlobalSettings.ACCURACY,
		power: number = 1
	): number {
		return UnitConverter.getConvertValue(value, unit, imperialDistanceUnit, accuracy, power);
	}
}
